import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

import RetailerFilter from "./RetailerFilter";
import ProductFilter from "./ProductFilter";
import ProvinceFilter from "./ProvinceFilter";

const PriceFilters = ({
  report,
  range,
  onRangeChange,
  granularity,
  onGranularity,
  filters,
  onFilters,
  retailerOpts = [],
  productOpts = [],
  provinceOpts = [],
  retailerLoading,
  productLoading,
  provinceLoading,
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          sx={{
            display: "grid",
            gap: 1,
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
              lg: "repeat(12, minmax(0, 1fr))",
            },
          }}
        >
          <DatePicker
            label="Start date"
            value={range?.startDate || null}
            onChange={(v) => onRangeChange({ ...range, startDate: v })}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  width: "100%",
                  gridColumn: { xs: "1 / -1", sm: "span 1", lg: "span 3" },
                },
              },
            }}
          />

          <DatePicker
            label="End date"
            value={range?.endDate || null}
            onChange={(v) => onRangeChange({ ...range, endDate: v })}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  width: "100%",
                  gridColumn: { xs: "1 / -1", sm: "span 1", lg: "span 3" },
                },
              },
            }}
          />

          <FormControl
            size="small"
            sx={{
              width: "100%",
              gridColumn: { xs: "1 / -1", sm: "span 2", lg: "span 2" },
            }}
          >
            <InputLabel id="price-granularity-label">Bucket</InputLabel>
            <Select
              labelId="price-granularity-label"
              label="Bucket"
              value={granularity}
              onChange={(e) => onGranularity(e.target.value)}
            >
              <MenuItem value="day">Day</MenuItem>
              <MenuItem value="month">Month</MenuItem>
            </Select>
          </FormControl>

          {report === "retailer" && (
            <RetailerFilter
              sx={{
                width: "100%",
                gridColumn: { xs: "1 / -1", sm: "span 2", lg: "span 4" },
              }}
              options={retailerOpts}
              value={filters?.retailerValues || []}
              loading={retailerLoading}
              onChange={(next) =>
                onFilters({
                  ...filters,
                  retailerValues: next,
                })
              }
            />
          )}

          {report === "product" && (
            <ProductFilter
              sx={{
                width: "100%",
                gridColumn: { xs: "1 / -1", sm: "span 2", lg: "span 4" },
              }}
              options={productOpts}
              value={filters?.productValues || []}
              loading={productLoading}
              onChange={(next) =>
                onFilters({
                  ...filters,
                  productValues: next,
                })
              }
            />
          )}

          {report === "province" && (
            <ProvinceFilter
              sx={{
                width: "100%",
                gridColumn: { xs: "1 / -1", sm: "span 2", lg: "span 4" },
              }}
              options={provinceOpts}
              value={filters?.provinceValues || []}
              loading={provinceLoading}
              onChange={(next) =>
                onFilters({
                  ...filters,
                  provinceValues: next,
                })
              }
            />
          )}
        </Box>
      </LocalizationProvider>
    </Box>
  );
};

export default PriceFilters;
